import React, { useEffect, useState } from 'react';

import { useSnackbar } from 'notistack';

import { CircularProgress, FormControlLabel, Stack, Switch, Typography } from '@mui/material';

import BedbankService from '~/services/BedbankService';

import NestedAccordion from './NestedAccordion';

export default function DynamicConfigurationsPage() {
  const [data, setData] = useState<Record<string, unknown> | null>(null);
  const [savingSpecialRequests, setSavingSpecialRequests] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    async function fetchConfiguration() {
      try {
        const data = await BedbankService.getDynamicConfigurations();
        setData(data.result);
      } catch (e) {
        console.error(e);
        enqueueSnackbar('Error loading dynamic configurations', { variant: 'error' });
      }
    }

    fetchConfiguration();
  }, [enqueueSnackbar]);

  async function handleTravelgateSpecialRequests(enabled: boolean) {
    setSavingSpecialRequests(true);
    try {
      await BedbankService.updateTravelgateSpecialRequests(enabled);
      const refreshed = await BedbankService.getDynamicConfigurations();
      setData(refreshed.result);
      enqueueSnackbar(enabled ? 'Travelgate special requests are on' : 'Travelgate special requests are off', {
        variant: 'success',
      });
    } catch (e) {
      console.error(e);
      enqueueSnackbar('Could not update Travelgate special requests', { variant: 'error' });
    } finally {
      setSavingSpecialRequests(false);
    }
  }

  if (data === null) {
    return <CircularProgress />;
  }

  const travelgateSpecialRequestsEnabled = data.travelgateSpecialRequestsEnabled === true;

  return (
    <>
      <Stack sx={{ px: 2, py: 1 }}>
        <FormControlLabel
          control={
            <Switch
              checked={travelgateSpecialRequestsEnabled}
              disabled={savingSpecialRequests}
              onChange={(_event, checked) => {
                handleTravelgateSpecialRequests(checked);
              }}
            />
          }
          label="Travelgate special requests"
        />
        <Typography variant="body2" color="text.secondary">
          Turns post-booking special requests on or off for every Travelgate bedbank. Other processes pick this up
          within two minutes. Expedia and Agoda are unchanged.
        </Typography>
      </Stack>
      {Object.entries(data).map(([key, value]) => (
        <NestedAccordion key={key} keyName={key} value={value} />
      ))}
    </>
  );
}
